module.exports = __webpack_public_path__ + "static/media/motorencapsulado4.d27cfd73.pdf";